module.exports = __webpack_public_path__ + "static/media/b20.3f0d115c.svg";